import style from "./style.module.scss";

const ORPHANED_TOOLTIP =
	"No definition matches this name, so it's probably not read by any code. Check before deleting: a setting the code reads but that was never added to the definitions script also shows here.";

/** Marks a setting whose name matches no definition */
export function OrphanedBadge() {
	return (
		<span className={style.orphanedBadge} title={ORPHANED_TOOLTIP}>
			Orphaned
		</span>
	);
}
